import { Box, Container, Typography } from "@mui/material";
import GestionStaff from "../../../components/staff/GestionStaff";
import BannerPreview from "../../../components/evento/BannerPreview";

/* Paso "Colaboradores" del alta de un evento: la misma gestión de staff que
 * el panel /eventos/:id/staff, sin listar a quien crea el evento. */
export const AgregarColaboradores = ({ eventId, isPublic }) => (
  <Container maxWidth="lg" sx={{ mt: 4 }}>
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062", mb: 2 }}>
        Agregar miembros a tu evento
      </Typography>
      <Typography variant="body1" sx={{ color: "#4b4d63" }}>
        Añadí miembros a tu evento para que te ayuden a gestionarlo. Podés asignarles distintos roles según las tareas que necesites que realicen.
      </Typography>
    </Box>

    {eventId && <GestionStaff eventoId={eventId} puedeGestionar ocultarCreador />}

    {isPublic && eventId && <BannerPreview eventId={eventId} />}
  </Container>
);
